import { Modal } from "@mantine/core";
import { Button } from "antd";
import { useSpendingLimit } from "@vojomo-core/shared";

export const SpendingLimitModal = () => {
  const { showModal, closeModal } = useSpendingLimit();

  return (
    <Modal
      opened={showModal}
      onClose={closeModal}
      title="Beta Usage Limit Reached"
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={true}
      centered
      size="md"
      styles={{
        title: {
          fontSize: "20px",
          fontWeight: 600,
          color: "#d32f2f"
        }
      }}
    >
      <div style={{ padding: "16px 0" }}>
        <p style={{ fontSize: "16px", marginBottom: "16px", color: "#333" }}>
          You've reached your limit for beta usage. We'd love to extend this
          limit for you. Please contact support (feedback@vojomo.com).
        </p>

        {/* <div
          style={{
            background: "#f5f5f5",
            padding: "16px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "8px",
            }}
          >
            <span style={{ fontWeight: 500 }}>Current Spend:</span>
            <span style={{ color: "#d32f2f", fontWeight: 600 }}>
              ${currentSpend.toFixed(2)}
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ fontWeight: 500 }}>Monthly Limit:</span>
            <span style={{ fontWeight: 600 }}>${limit.toFixed(2)}</span>
          </div>
        </div> */}

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="primary"
            onClick={closeModal}
            style={{
              background: "#2c1561",
              borderColor: "#2c1561"
            }}
          >
            I Understand
          </Button>
        </div>
      </div>
    </Modal>
  );
};
